<mat-card class="card-demo">
  <mat-card-title class="topline">
    <h2>
      Audit Template: {{ auditName }}@if (!sharePermission) {
      <b>(View Only)</b>
      }
    </h2>
    <mat-slide-toggle
      class="second-level-screening-toggle"
      [class.is-checked]="showSecondLevelScreening"
      [checked]="showSecondLevelScreening"
      [disabled]="!sharePermission"
      [hideIcon]="true"
      (change)="onToggleSecondLevelScreening($event.checked)"
    >
      Detailed Requirement Screening
    </mat-slide-toggle>
    <button mat-button (click)="onBackSummary()">
      <mat-icon aria-hidden="true" aria-label="Next">arrow_back</mat-icon>Back
      to Summary
    </button>
  </mat-card-title>
  <mat-card-content class="large">
    <div fxLayout="column" fxFill>
      <div fxLayout fxFlex>
        <div
          class="one"
          fxFlex="70"
          fxLayout="column"
          fxLayoutAlign="start stretch"
        >
          <!--app-list-rulebook (and its own Previous/Next) is hidden below 920px - this
          keeps rulebook navigation reachable without it, delegating to the same
          component's methods via #listRulebook rather than duplicating them. -->
          <div
            class="mobile-rb-nav"
            fxLayout="row"
            fxLayoutAlign="space-between center"
          >
            <button mat-button (click)="listRulebook.onPreviousRulebook()">
              <mat-icon aria-hidden="true" aria-label="Previous"
                >arrow_back</mat-icon
              >Previous
            </button>
            <button
              mat-button
              class="reverse-icon-button"
              (click)="listRulebook.onNextRulebook()"
            >
              Next<mat-icon aria-hidden="true" aria-label="Next"
                >arrow_forward</mat-icon
              >
            </button>
          </div>
          <app-answer-question
            fxFlex
            [appSect$]="this.appSect$"
            [noQuestionSections$]="this.noQuestionSections$"
            [rbName]="this.selectedRbName"
            [editable]="this.sharePermission"
            [csskey]="+this.csskey"
            [appkey]="+this.appkey"
            [showSecondLevelScreening]="this.showSecondLevelScreening"
            (answerApp)="onAnswerApp($event)"
            (viewSigChange)="onViewSigChange($event)"
            (sigResolved)="onSigResolved($event)"
          >
          </app-answer-question>
        </div>
        <div class="two" fxFlex="30" fxLayoutAlign="start start">
          <app-list-rulebook
            [csskey]="this.csskey"
            [auditName]="this.auditName"
            [rbList]="this.rulebookList"
            [selected]="this.appkey"
            (selectedAppkey)="onClickRulebook($event)"
            class="list-rulebook"
          >
          </app-list-rulebook>
        </div>
      </div>
    </div>
  </mat-card-content>
  <mat-card-footer class="bottomPad">
    <div class="hint"></div>
  </mat-card-footer>
</mat-card>
@if (service.loading) {
<div class="spinner-container">
  <mat-spinner></mat-spinner>
</div>
}
